import { useEffect, useRef } from 'react';
import { useGameLoop } from '../hooks/useGameLoop';

const CANVAS_WIDTH = 800;
const CANVAS_HEIGHT = 1200;

export const GameCanvas = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useGameLoop(canvasRef);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = CANVAS_WIDTH * dpr;
    canvas.height = CANVAS_HEIGHT * dpr;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="game-canvas"
      style={{
        display: 'block',
        touchAction: 'none',
        imageRendering: 'pixelated'
      }}
    />
  );
};

export default GameCanvas;
